<script>
import InvoiceExportList from '../../components/invoice/InvoiceExportList.vue'

export default {
  components: {
    InvoiceExportList
  },
}
</script>


<template>
  <InvoiceExportList
      endpoint="invoice/pdf/export"
  />
</template>
